import { z } from 'zod';

/**
 * What kind of legal document a row is (N16).
 *
 * The type is **not** the identity of a document — `legal_documents.key` is.
 * The type exists so clients can treat classes of document differently without
 * matching on a staff-authored slug: mobile links "Terms" from the signup
 * screen and "Privacy" from settings, and a `custom` document is rendered by
 * whatever screen references its key.
 *
 * `marriage_responsibility` is a first-class type rather than a `custom` row
 * because `03-legal-consent.md` names it: the owner may prefer the
 * marriage-responsibility disclaimer surfaced separately from the terms, and
 * that decision must not require a schema change or a client release.
 */
export const LEGAL_DOC_TYPES = ['terms', 'privacy', 'marriage_responsibility', 'custom'] as const;

export const LegalDocTypeSchema = z.enum(LEGAL_DOC_TYPES);

export type LegalDocType = (typeof LEGAL_DOC_TYPES)[number];

const DOC_TYPE_SET: ReadonlySet<string> = new Set<string>(LEGAL_DOC_TYPES);

/** Narrows a plain string — what a route parameter or a stored row passes through. */
export function isLegalDocType(value: string): value is LegalDocType {
  return DOC_TYPE_SET.has(value);
}
